"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
exports.__esModule = true;
exports.default = void 0;
var _core = require("@uppy/core");
var _preact = require("preact");
var _Editor = _interopRequireDefault(require("./Editor.js"));
var _locale = _interopRequireDefault(require("./locale.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
var packageJson = {
  "version": "2.4.6"
};
var defaultCropperOptions = {
  viewMode: 0,
  background: false,
  autoCropArea: 1,
  responsive: true,
  minCropBoxWidth: 70,
  minCropBoxHeight: 70,
  croppedCanvasOptions: {},
  initialAspectRatio: 0
};
var defaultActions = {
  revert: true,
  rotate: true,
  granularRotate: true,
  flip: true,
  zoomIn: true,
  zoomOut: true,
  cropSquare: true,
  cropWidescreen: true,
  cropWidescreenVertical: true
};
var defaultOptions = {
  // `quality: 1` increases the image size by orders of magnitude - 0.8 seems to be the sweet spot.
  // see https://github.com/fengyuanchen/cropperjs/issues/538#issuecomment-1776279427
  quality: 0.8,
  actions: defaultActions,
  cropperOptions: defaultCropperOptions
};
var ImageEditor = exports.default = /*#__PURE__*/function (_UIPlugin) {
  function ImageEditor(uppy, opts) {
    var _this;
    _classCallCheck(this, ImageEditor);
    _this = _callSuper(this, ImageEditor, [uppy, _objectSpread(_objectSpread(_objectSpread({}, defaultOptions), opts), {}, {
      actions: _objectSpread(_objectSpread({}, defaultActions), opts == null ? void 0 : opts.actions),
      cropperOptions: _objectSpread(_objectSpread({}, defaultCropperOptions), opts == null ? void 0 : opts.cropperOptions)
    })]);
    _this.save = function () {
      var saveBlobCallback = function saveBlobCallback(blob) {
        var _this$getPluginState = _this.getPluginState(),
          currentImage = _this$getPluginState.currentImage;
        _this.uppy.setFileState(currentImage.id, {
          // Reinserting image's name and type, because .toBlob loses both.
          data: new File([blob], currentImage.name, {
            type: blob.type
          }),
          size: blob.size,
          preview: undefined
        });
        var updatedFile = _this.uppy.getFile(currentImage.id);
        _this.uppy.emit('thumbnail:request', updatedFile);
        _this.setPluginState({
          currentImage: updatedFile
        });
        _this.uppy.emit('file-editor:complete', updatedFile);
      };
      var _this$getPluginState2 = _this.getPluginState(),
        currentImage = _this$getPluginState2.currentImage;

      // Fixes black 1px lines on odd-width images.
      // This should be removed when cropperjs fixes this issue.
      // (See https://github.com/transloadit/uppy/issues/4305 and https://github.com/fengyuanchen/cropperjs/issues/551).
      var croppedCanvas = _this.cropper.getCroppedCanvas({});
      if (croppedCanvas.width % 2 !== 0) {
        _this.cropper.setData({
          width: croppedCanvas.width - 1
        });
      }
      if (croppedCanvas.height % 2 !== 0) {
        _this.cropper.setData({
          height: croppedCanvas.height - 1
        });
      }
      _this.cropper.getCroppedCanvas(_this.opts.cropperOptions.croppedCanvasOptions).toBlob(saveBlobCallback, currentImage.type, _this.opts.quality);
    };
    _this.storeCropperInstance = function (cropper) {
      _this.cropper = cropper;
    };
    _this.selectFile = function (file) {
      _this.uppy.emit('file-editor:start', file);
      _this.setPluginState({
        currentImage: file
      });
    };
    _this.id = _this.opts.id || 'ImageEditor';
    _this.title = 'Image Editor';
    _this.type = 'editor';
    _this.defaultLocale = _locale.default;
    _this.i18nInit();
    return _this;
  }

  // eslint-disable-next-line class-methods-use-this
  _inherits(ImageEditor, _UIPlugin);
  return _createClass(ImageEditor, [{
    key: "canEditFile",
    value: function canEditFile(file) {
      if (!file.type || file.isRemote) {
        return false;
      }
      var fileTypeSpecific = file.type.split('/')[1];
      if (/^(jpe?g|gif|png|bmp|webp)$/.test(fileTypeSpecific)) {
        return true;
      }
      return false;
    }
  }, {
    key: "install",
    value: function install() {
      this.setPluginState({
        currentImage: null
      });
      var target = this.opts.target;
      if (target) {
        this.mount(target, this);
      }
    }
  }, {
    key: "uninstall",
    value: function uninstall() {
      var _this$getPluginState3 = this.getPluginState(),
        currentImage = _this$getPluginState3.currentImage;
      if (currentImage) {
        var file = this.uppy.getFile(currentImage.id);
        this.uppy.emit('file-editor:cancel', file);
      }
      this.unmount();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$getPluginState4 = this.getPluginState(),
        currentImage = _this$getPluginState4.currentImage;
      if (currentImage === null || currentImage.isRemote) {
        return null;
      }
      return (0, _preact.h)(_Editor.default, {
        currentImage: currentImage,
        storeCropperInstance: this.storeCropperInstance,
        save: this.save,
        opts: this.opts,
        i18n: this.i18n
      });
    }
  }]);
}(_core.UIPlugin);
ImageEditor.VERSION = packageJson.version;